export default import.meta.ROLLDOWN_FILE_URL_GVTVJGL1VMtq8AiFX_JFoQ